<div class="priority-board" cdkDropListGroup>
  <section class="priority-pool">
    <h4>{{ 'greenManure.availablePriorities' | translate }}</h4>
    <div
      class="priority-drop-zone priority-pool-options"
      cdkDropList
      [cdkDropListData]="available()"
      [cdkDropListSortingDisabled]="true"
      (cdkDropListDropped)="place($event.item.data, null)"
    >
      @for (priority of available(); track priority) {
        <div class="priority-drag-card" cdkDrag [cdkDragData]="priority" [cdkDragDisabled]="full()">
          <mat-icon class="priority-drag-handle" aria-hidden="true">drag_indicator</mat-icon>
          <div class="priority-copy">
            <div class="priority-title">
              <mat-icon aria-hidden="true">{{ priorityIcons[priority] }}</mat-icon>
              <strong>{{ priorityLabelKeys[priority] | translate }}</strong>
            </div>
          </div>
          <button
            mat-icon-button
            type="button"
            [disabled]="full()"
            [attr.aria-label]="
              ('greenManure.choosePriority' | translate) + ': ' + (priorityLabelKeys[priority] | translate)
            "
            (click)="place(priority, selection().length)"
            (mousedown)="$event.stopPropagation()"
            (touchstart)="$event.stopPropagation()"
          >
            <mat-icon>add</mat-icon>
          </button>
        </div>
      }
    </div>
  </section>
  <section class="priority-ranking">
    <h4>{{ 'greenManure.topThree' | translate }}</h4>
    <div class="priority-drop-zone" cdkDropList [cdkDropListData]="selection()" (cdkDropListDropped)="drop($event)">
      @for (priority of selection(); track priority; let index = $index) {
        <div class="priority-drag-card" cdkDrag [cdkDragData]="priority">
          <mat-icon class="priority-drag-handle" aria-hidden="true">drag_indicator</mat-icon>
          <span class="priority-rank-number">{{ index + 1 }}</span>
          <div class="priority-copy">
            <div class="priority-title">
              <mat-icon aria-hidden="true">{{ priorityIcons[priority] }}</mat-icon>
              <strong>{{ priorityLabelKeys[priority] | translate }}</strong>
            </div>
            <span>{{ 'greenManure.' + weightKeys[index] | translate }}</span>
          </div>
          <div class="priority-controls">
            <button
              mat-icon-button
              type="button"
              [attr.aria-label]="
                ('greenManure.removePriority' | translate) + ': ' + (priorityLabelKeys[priority] | translate)
              "
              (click)="place(priority, null)"
              (mousedown)="$event.stopPropagation()"
              (touchstart)="$event.stopPropagation()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>
      }
      @if (!full()) {
        <p class="priority-drop-hint">{{ 'greenManure.dropHere' | translate }}</p>
      }
    </div>
  </section>
</div>
